export default "__VITE_ASSET__ChdVrr8C__"